import React from "react";
import ReactDOM from "react-dom";

import { BrowserRouter } from "react-router-dom";
import "./assets/base.scss";
import Main from "./components/Main";
import { Provider } from "react-redux";
import { persistor, store } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import AppErrorBoundary from "./common/ErrorBoundary";
import { SocketProvider } from "./helpers/SocketProvider";

const rootElement = document.getElementById("root");

const renderApp = (Component) => {
  ReactDOM.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <AppErrorBoundary>
            <SocketProvider >
              <Component />
            </SocketProvider>
          </AppErrorBoundary>
        </BrowserRouter>
      </PersistGate>
    </Provider>,
    rootElement
  );
};

renderApp(Main);

if (module.hot) {
  module.hot.accept("./components/Main", () => {
    const NextApp = require("./components/Main").default;
    renderApp(NextApp);
  });
}
